import { initializeApp, getApps, getApp, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { getDatabase, type Database } from 'firebase/database';
import { getFunctions, type Functions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: 'AIzaSyBF7ByZtKTvE7ZDs02Hsd92XN-1CNr3N8w',
  authDomain: 'geocuidado-3757e.firebaseapp.com',
  databaseURL: 'https://geocuidado-3757e-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'geocuidado-3757e',
  storageBucket: 'geocuidado-3757e.appspot.com',
  appId: 'geocuidado-web',
};

export const firebaseApp: FirebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const auth: Auth = getAuth(firebaseApp);
export const db: Database = getDatabase(firebaseApp);
export const fns: Functions = getFunctions(firebaseApp, 'europe-west1');

export const CENTER_ID = (import.meta.env.VITE_CENTER_ID as string) || '0001';
